import React from 'react'
import PropTypes from 'prop-types'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import MerchantTable from '@nexidigital/merchanttable'
import formattedMessage from './languageModule'
import { getCountryLabelFromAlpha3, formatCurrency, formatThousands } from 'Utility/globalMethods'
import { useIntl } from 'react-intl'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import './ForeignCardDetail.scss'

const formatPercentage = (value) => {
  if (value === 0) return '0'
  const formatted = value.toFixed(2)
  return formatThousands(parseFloat(formatted))
}

function ForeignCardSecondPeriodDetail ({ countries, totals, referredPeriod }) {
  const intl = useIntl()
  const locale = intl.locale || 'it'
  const regionNames = new Intl.DisplayNames([locale], { type: 'region' })

  const rows = (Array.isArray(countries) ? countries : []).map(item => ({
    paymentMethod: (
      <div className='tableCountryRow'>
        {item.urlCountry && <img className='tableCountryImg' src={item.urlCountry} alt={getCountryLabelFromAlpha3(item.country, regionNames)} />}
        {getCountryLabelFromAlpha3(item.country, regionNames)}
      </div>
    ),
    transaction: <b>{formatPercentage(item.percent)}%</b>,
    transacted: <b>{formatCurrency(item.transactionCost)}</b>
  }))

  return (
    <div className='foreignCardDetailPeriodDetail'>
      <div className='foreignCardDetailPeriodDates'>
        <p className=''>{formattedMessage.period}</p>
        <MerchantTableBadge label={referredPeriod[2]} status='neutralLight' /> -
        <MerchantTableBadge label={referredPeriod[3]} status='neutralLight' />
      </div>
      <div className='foreignCardDetailPeriodContent'>
        <MerchantGenericCard title={formattedMessage.foreignCards} subtitle={formattedMessage.foreignCardsSubtitle}>
          <div className='keyIndicatorForeignCard'>
            <div className='keyIndicatorRow'>
              <div className='keyIndicatorLabel'>{formattedMessage.nations}</div>
              <div className='keyIndicatorValue'>{totals.countriesCount}</div>
            </div>
            <div className='keyIndicatorRow'>
              <div className='keyIndicatorLabel'>{formattedMessage.transactions}</div>
              <div className='keyIndicatorValue'>{formatThousands(totals.transactionsCount)}</div>
            </div>
            <div className='keyIndicatorRow'>
              <div className='keyIndicatorLabel'>{formattedMessage.transacted}</div>
              <div className='keyIndicatorValue'>{formatCurrency(totals.transactionsCost)}</div>
            </div>
          </div>

          <div className='tableForeignCardDetail'>
            <MerchantTable
              name='merchantPortal'
              tabIndex={-1}
              columns={[{
                id: 'paymentMethod',
                label: formattedMessage.payment,
                sx: { width: '33.33%' }
              }, {
                id: 'transaction',
                label: formattedMessage.transactions,
                align: 'right',
                sx: { width: '33.33%' }
              }, {
                id: 'transacted',
                label: formattedMessage.transacted,
                align: 'right',
                sx: { Width: '33.33%' }
              }]}
              onPagination={() => { }}
              onSort={() => { }}
              rows={rows}
              sx={{ border: '0' }}
            />
          </div>
        </MerchantGenericCard>
      </div>
    </div>
  )
}

ForeignCardSecondPeriodDetail.propTypes = {
  totals: PropTypes.object,
  countries: PropTypes.array,
  referredPeriod: PropTypes.array
}

ForeignCardSecondPeriodDetail.defaultProps = {
  totals: {},
  countries: [],
  referredPeriod: ['-', '-', '-', '-']
}

export default ForeignCardSecondPeriodDetail
